import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7zsr03d53s: FaireBrandEntity = {
  token: "b_7zsr03d53s",
  type: "brand",
  name: "Cedar and Myrrh",
  avatarUrl:
    "https://cdn.faire.com/fastly/81d2385d3ca8e04549eea619c67c3488769e3a6b6b950c74d7bcfbc866215be7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d820032ee34dc79a43aae16c8e8c09bb82cdffba017ee381fe15d87f0c057b50.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/81d2385d3ca8e04549eea619c67c3488769e3a6b6b950c74d7bcfbc866215be7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d820032ee34dc79a43aae16c8e8c09bb82cdffba017ee381fe15d87f0c057b50.jpeg",
  location: "New York , NY, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 237,
  isTopShop: true,
  isInsider: true,
  description:
    "At Cedar & Myrrh, we strive to bring serenity and brilliance to the world. We believe that true beauty is derived from how we feel. We have created a full line of natural, sustainable wellbeing products and designed bespoke rituals to help you achieve outer beauty and inner peace. Our wide selection of holistic products and their accompanying rituals set the perfect tone for a healthier lifestyle. We mindfully select products that are ethically made and free of harmful synthetic ingredients to guarantee a clean, healthy environment and a more glowing you.\n\n With over a decade of international industry experience in beauty, wellness, skincare formulation and aromatherapy, Cedar & Myrrh founder, Misun Delmon, is dedicated to providing natural products and high-quality experiences that make you feel as radiant as you look. Feel beautiful, live healthy, and pract",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:19.045Z",
    importedBy: "entity-db-cli",
  },
};
